/**
 * Extract color value from mappings in constants
 * @param colorsValues the mapping of colors and values
 * @param color the color specified in props
 * @param defaultColor the default color to apply (primary as default)
 */
export const getValueForPropColorOrDefault = (
  colorsValues: NonNullable<unknown>,
  propColor: string,
  defaultPropColor: string = 'primary'
) => {
  return (propColor && colorsValues[propColor]) || colorsValues[defaultPropColor];
};
